// extracted by mini-css-extract-plugin
module.exports = {"BackgroundSilverLight":"_3Z2ey"};